import { useRef } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import clsx from "clsx";
import objectPath from "object-path";

import MenuItemText from "_metronic/layout/aside/MenuItemText";
import MenuSubmenu from "_metronic/layout/aside/MenuSubmenu";

const MenuItem = (props) => {
  const asideLeftLIRef = useRef();
  const permissions = useSelector((state) => state.workspaces?.activeWorkspace?.permissions || []);
  const isDropdown = document.body.classList.contains("kt-aside-menu--dropdown");

  const submenuToggle =
    props.item.toggle === "click"
      ? "click"
      : objectPath.get(props.item, "submenu.type") === "tabs"
        ? "tabs"
        : "hover";

  /**
   * Use for fixed left aside menu, to show menu on mouseenter event.
   * @param event Event
   */
  const mouseEnter = () => {
    if (!isDropdown) {
      return;
    }

    if (props.item.submenu) {
      asideLeftLIRef.current.classList.add("kt-menu__item--hover");
      asideLeftLIRef.current.setAttribute("data-ktmenu-submenu-toggle", submenuToggle);
    }
  };

  /**
   * Mouse Leave event
   * @param event: MouseEvent
   */
  const mouseLeave = () => {
    if (!isDropdown) {
      return;
    }

    if (props.item.submenu && submenuToggle === "hover") {
      asideLeftLIRef.current.classList.remove("kt-menu__item--hover");
      asideLeftLIRef.current.removeAttribute("data-ktmenu-submenu-toggle");
    }
  };

  const isMenuItemIsActive = (item) => {
    if (item.submenu) {
      return isMenuRootItemIsActive(item);
    }

    if (!item.page) {
      return false;
    }

    return props.currentUrl.indexOf(item.page) !== -1;
  };

  const isMenuRootItemIsActive = (item) => {
    for (const subItem of item.submenu) {
      if (isMenuItemIsActive(subItem)) {
        return true;
      }
    }

    return false;
  };

  const { item, currentUrl, parentItem, layoutConfig, onMenuItemSelected } = props;
  if (item.permission && !permissions.includes(item.permission)) return null;
  const isActive = isMenuItemIsActive(item);

  return (
    <li
      ref={asideLeftLIRef}
      data-placement="right"
      data-ktmenu-submenu-mode={item.mode}
      onMouseEnter={mouseEnter}
      onMouseLeave={mouseLeave}
      className={clsx(
        "kt-menu__item",
        {
          "kt-menu__item--submenu": item.submenu,
          "kt-menu__item--open kt-menu__item--here": isActive && item.submenu,
          "kt-menu__item--active kt-menu__item--here": isActive && !item.submenu,
          "kt-menu__item--icon-only": item["icon-only"],
        },
        item["custom-class"]
      )}
      data-ktmenu-dropdown-toggle-class={item["dropdown-toggle-class"]}
    >
      {!item.submenu && (
        <Link
          onClick={() => onMenuItemSelected?.(item)}
          to={`/${item.page}`}
          className="kt-menu__link kt-menu__toggle d-flex justify-content-center align-items-center"
        >
          <MenuItemText item={item} isActive={isActive} parentItem={parentItem} />
        </Link>
      )}
      {item.submenu && (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a className="kt-menu__link kt-menu__toggle d-flex justify-content-center align-items-center">
          <MenuItemText item={item} parentItem={parentItem} />
        </a>
      )}
      {item.submenu && (
        <div className="kt-menu__submenu">
          <span className="kt-menu__arrow" />

          {item["custom-class"] === "kt-menu__item--submenu-fullheight" && (
            <div className="kt-menu__wrapper">
              <MenuSubmenu item={item} parentItem={item} currentUrl={currentUrl} />
            </div>
          )}

          {item["custom-class"] !== "kt-menu__item--submenu-fullheight" && (
            <MenuSubmenu
              item={item}
              parentItem={item}
              currentUrl={currentUrl}
              layoutConfig={layoutConfig}
            />
          )}
        </div>
      )}
    </li>
  );
};

export default MenuItem;
